import React from 'react'
import TimeTabs from 'components/Modules/Slots/ScheduleSettings/components/TimeTabs/TimeTabs'

function Duration() {
  return (
    <div>
      <TimeTabs />
    </div>
  )
}

export default Duration
